export default __webpack_public_path__ + "static/media/logo_new.6e49b2c2.svg";